
    import { computed, defineComponent, ref } from 'vue'
    import { useRoute } from 'vue-router/composables'

    import HeaderNavItem from '@/app/components/header/HeaderNavItem.vue'
    import HeaderNavItemAbsolute from '@/app/components/header/HeaderNavItemAbsolute.vue'
    import HeaderNavItemDropdown from '@/app/components/header/HeaderNavItemDropdown.vue'
    import { useCategoriesStore } from '@/app/stores/categories'

    import { siteNavElement } from '@/common/json-ld/page-elements'
    import { useVuetify } from '@/common/composables/libs/vuetify'
    import { useSharedSettingsStore } from '@/common/stores/shared-settings'

    export default defineComponent({
        components: {
            HeaderNavItemDropdown,
            HeaderNavItemAbsolute,
            HeaderNavItem
        },
        setup () {
            const route = useRoute()
            const vuetify = useVuetify()
            const categoriesStore = useCategoriesStore()
            const settingsStore = useSharedSettingsStore()

            const openedSubmenu = ref<string>()

            const isMobile = computed(() => vuetify.breakpoint.mdAndDown)
            const mainMenuCategories = computed(() => categoriesStore.mainMenuCategories)
            const podcastsUrl = computed(() => settingsStore.setting('social-mixcloud'))

            const isSubmenuActive = (paths: string | Array<string>): boolean => {
                paths = Array.isArray(paths) ? paths : [paths]

                paths = paths.map(path => {
                    return path.startsWith('/') ? path : `/${path}`
                })

                return paths.some(path => {
                    return route.path.indexOf(path) === 0
                })
            }

            const isSubmenuOpened = (submenu: string): boolean => {
                return !isMobile.value || submenu === openedSubmenu.value
            }

            const openSubmenu = (submenu: string): void => {
                if (!isMobile.value) {
                    return
                }

                openedSubmenu.value = openedSubmenu.value === submenu ? undefined : submenu
            }

            return {
                isMobile,
                jsonLd: siteNavElement,
                mainMenuCategories,
                podcastsUrl,
                isSubmenuActive,
                isSubmenuOpened,
                openSubmenu
            }
        }
    })
